import { create } from 'zustand'
import type { AgentId } from '../types/assistant'

interface AssistantState {
  isOpen: boolean
  currentAgentId: AgentId
  hasUserSwitched: boolean
  toggle: () => void
  open: () => void
  close: () => void
  switchAgent: (agentId: AgentId) => void
  setDefaultAgent: (agentId: AgentId) => void
}

export const useAssistantStore = create<AssistantState>((set) => ({
  isOpen: false,
  currentAgentId: 'agent-alex',
  hasUserSwitched: false,

  toggle: () => set((s) => ({ isOpen: !s.isOpen })),
  open: () => set({ isOpen: true }),
  close: () => set({ isOpen: false }),

  switchAgent: (agentId) =>
    set({ currentAgentId: agentId, hasUserSwitched: true }),

  setDefaultAgent: (agentId) =>
    set((s) => (s.hasUserSwitched ? s : { currentAgentId: agentId })),
}))
